import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import PrepaidCardNotes from '@components/prepaid/PrepaidCardNotes';
import TermNotes from '@components/term/TermNotes';
import styled from '@emotion/styled';
import useGiftItem from '@hooks/gift/useGiftItem';
import { GiftItemType } from '@models/gift';
import GiftOrderProvider from '@providers/GiftOrderProvider';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CardAmount from './components/CardAmount';
import CardInfo from './components/CardInfo';
import Complete from './components/Complete';
import Footer from './components/Footer';
import ItemInfo from './components/ItemInfo';
import Message from './components/Message';
import PaymentMethod from './components/PaymentMethod';
import Receiver from './components/Receiver';
import Sender from './components/Sender';
import SendMethod from './components/SendMethod';

interface Params {
    type: GiftItemType;
    giftItemId: string;
    qty: number;
    giftCardImageId?: string;
}

declare module '@stackflow/config' {
    interface Register {
        GiftOrderActivity: Params;
    }
}

const GiftOrderActivity: ActivityComponentType<'GiftOrderActivity'> = ({ params }) => {
    const {
        type, giftItemId, qty, giftCardImageId,
    } = params;
    const isCard = type === 'CASH';
    const giftItem = useGiftItem(giftItemId);
    const { t } = useTranslation('gift');
    return (
        <AppScreen>
            <GiftOrderProvider>
                <form style={{ width: '100%', height: '100vh' }}>
                    {giftItem && (
                        <CtaLayout header={<Header title={t('giftOrder.title')}/>}
                            footer={<Footer type={type}
                                giftItem={giftItem}
                                qty={qty}
                                giftCardImageId={giftCardImageId} />} >
                            {isCard ? (<CardInfo giftCardImageId={giftCardImageId!}/>)
                                : (<ItemInfo giftItem={giftItem} qty={qty}/>)}
                            <Container fullWidth
                                spacing={38} >
                                <Message/>
                                <Sender/>
                                <SendMethod/>
                                <Receiver/>
                                {isCard && (<CardAmount amount={giftItem.salePrice}/>)}
                                {/* <PaymentMethod/> */}
                            </Container>
                            <Divider/>
                            <TermNotes displayContext='GIFT' />
                            <Complete/>
                        </CtaLayout>
                    )}
                </form>
            </GiftOrderProvider>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding: 32px 20px 38px;
`;

export default GiftOrderActivity;
